import React from "react";
import { Nav } from "../../../../layouts/navbar/nav";
import images from "../../../../constant/images";
import {
  PiFacebookLogoLight,
  PiGoogleLogo,
  PiTwitterLogo,
} from "react-icons/pi";
import Header from "../../../../layouts/header";

export const Discovering = () => {
  return (
    <>
      <div className="flex flex-col gap-[2rem]  mb-[5rem]">
        {/* <div
          style={{
            backgroundImage: `url(${images.Industry})`,
            height: "60vh",
            backgroundPosition: "40%",
            backgroundRepeat: "no-repeat",
            marginBottom: "0/5rem",
            backgroundSize: "cover",
            position: "relative",
          }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-25"></div>
          <div>
            <Nav />
          </div>
          <div className="h-[50%] flex items-center justify-center">
            <h1 className="text-center relative text-white text-6xl mt-[3.5rem] custom-font">
              Non classé
            </h1>
          </div>
          <svg
            className="absolute bottom-[-9%] left-0 "
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1440 320"
          >
            <path
              class="white"
              fill="#fff"
              fill-opacity="1"
              d="M0,224L60,213.3C120,203,240,181,360,186.7C480,192,600,224,720,245.3C840,267,960,277,1080,250.7C1200,224,1300,170,1380,140L1440,120L1440,320L1380,320C1300,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"
            ></path>
          </svg>
        </div> */}
        <Header image={images.Industry} title={"GTM GOLF BLOG"} />
      </div>

      <div className="px-4 sm:px-8 md:px-12 lg:px-[12rem] mb-[8rem]">
        <div className="flex flex-col md:flex-row gap-6">
          <div className="flex flex-col gap-2">
            <p className="flex flex-col px-3 py-1 items-center bg-[#45ac4d] text-white font-bold text-lg sm:text-xl">
              28 <span className="text-sm sm:text-base font-medium">Nov</span>
            </p>
            <div className="flex flex-col gap-2">
              <div className="px-3 py-4 text-3xl text-[#4c67a2] border-2">
                <PiFacebookLogoLight />
              </div>
              <div className="px-3 py-4 text-3xl text-[#00acee] border-2">
                <PiTwitterLogo />
              </div>
              <div className="px-3 py-4 text-3xl text-[#d77066] border-2">
                <PiGoogleLogo />
              </div>
            </div>
          </div>

          <div className="flex flex-col gap-6">
            <p className="text-3xl sm:text-4xl md:text-5xl custom-font">
              Golf: discovering the fantastic offer of Morocco
            </p>
            <p className="text-[#888686] text-lg sm:text-xl leading-relaxed w-full md:w-[75vw]">
              The housewarming of the Morocco Golf Cup takes place this Friday
              at the Zoute. This amateur competition reserved for seniors aims
              to highlight the fantastic golfing offer of Morocco to Belgian
              players.
              <br />
              <br />
              Morocco is a dream destination for golfers. To its sunny climate
              all year round and its high-level hotel infrastructure, the
              country adds high-quality courses perfectly maintained and
              manicured. The spots of Agadir, Essaouira, Tangier, Rabat and of
              course Marrakech are particularly popular with connoisseurs.
              <br />
              <br />
              It was under the leadership of King Hassan II that the sport of
              St. Andrews developed in Morocco during the second half of the
              20th century. The monarch was a true swing enthusiast, to the
              point of having hired, as a personal trainer, the famous Butch
              Harmon, future coach of Tiger Woods! But it is in Tangier that was
              born, in 1914, under the era of Sultan Moulay Abdelaziz, the first
              Moroccan golf club and one of the first of the African continent.
              <br />
              <br />
              Designed by the English architect Henry Cotton, it was called the
              Diplomatic Country Club and was mainly frequented by ambassadors
              and businessmen.
              <br />
              <br />
              A little later, in 1927, the Royal Golf Club of Marrakech was
              born. Work of Gustave Golias and Arnaud Massy, it quickly became
              the favorite course of King Hassan II. And it is still one of the
              most prestigious in the country. Throughout its history, it has
              hosted many major international competitions. Several heads of
              state, such as Winston Churchill or Ike Eisenhower, loved to relax
              in the shade of palm trees.
              <br />
              <br />
              The Royal Golf Dar Es Salam is also a must. It was designed in
              1971 on the initiative of Hassan II, who asked the mythical
              American architect Robert Trent Jones to transform one of his
              properties in Rabat into a fabulous golf complex, marked by cork
              oaks and umbrella pines. A pure wonder that always makes
              reference.
              <br />
              <br />
              Today, golf has become an important tourist asset for Morocco,
              which lists, on its territory, forty courses all more beautiful
              than the others. "They are often integrated into luxury resorts,
              which is ideal for visitors," says Rabia Talhimet, Benelux
              Director of the Moroccan National Tourism Office.
              <br />
              <br />
              The airline Royal Air Maroc also cares for the comfort of birdies
              hunters. "From Brussels we offer many direct flights to
              Casablanca, Marrakech, Tangier, Rabat and Nador. Other
              destinations are served via the Casablanca Hub such as Agadir, Fez
              or Errachida. With the bonus, free golf bag. This is obviously a
              real privilege," confirms Walid El Khassal, Benelux Director of
              Royal Air Maroc in Belgium.
              <br />
              <br />
              It is to (re)highlight this magnificent destination with Belgian
              players that was created the Morocco Golf Cup, whose first edition
              starts this Friday, April 28 at the Royal Zoute. This new
              competition is reserved for senior players (50 years and older).
              <br />
              <br />
              It will therefore logically compete during the "Seniors Days,"
              with five rounds on the calendar: Le Zoute (28 April), Waterloo (9
              May), La Tournette (11 July), Sept Fontaines (5 September) and
              Naxhelet (12 September). The Belgian final is scheduled for 9
              October at the Golf Château de la Tournette in Nivelles.
              <br />
              <br />
              It will bring together the winners of the different qualifying
              rounds. And ten teams will have the privilege of meeting in
              December for the grand final on two of the most renowned courses
              in Marrakech: the Rotana Palmeraie (par 72), designed around lakes
              by the famous American architect Robert Trent Jones Sr, and the Al
              Maaden (par 73), majestic work of Kyle Philips.
              <br />
              <br />
              Thirty-six very challenging holes with the Atlas Mountains as a
              backdrop: you can’t dream of a better green setting!
            </p>
          </div>
        </div>
      </div>

      {/* <div className="flex flex-col ps-[7rem] mb-[8rem]">
        <h1 className="text-2xl  custom-font">Leave A Reply</h1>
        <p className="text-[#7c7c7c] text-[19px] font-[500] ">
          Vous devez <span className="text-[#45ac4d]">vous connecter</span> pour
          publier un commentaire.
        </p>
      </div> */}
    </>
  );
};
